import { Pipe, PipeTransform } from '@angular/core';
import { ExportType } from '@app/shared/enums/ExportType.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'exportType',
    standalone: false
})
export class ExportTypePipe implements PipeTransform {
  public exportType = ExportType;
  public exportTypesList: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
   }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedTypes = states
      .map(state => {
        const key = Object.keys(ExportType).find(
          k => ExportType[k as keyof typeof ExportType] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedTypes.length > 0
      ? translatedTypes.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.exportTypesList = [];

    for (const [propertyKey, propertyValue] of Object.entries(ExportType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.exportTypesList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.exportTypesList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ExportType)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return { id: propertyValue, name: nameAndText, text: nameAndText };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ExportType)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
